module.exports = __webpack_public_path__ + "img/Kortlueke2.f40f0f00.jpg";